import { Typography, Link } from "@mui/material";
import { Link as RouterLink, useParams } from 'react-router-dom';
import AllergenDto from "../../../models/AllergenDto";
import { ALLGERNS_URL, HOMEPAGE } from "../../../utils/Constants";
import { useTranslation } from "react-i18next";

interface AllergenProps {
    allergens: AllergenDto[];
}

export default function ItemAllergenDisplayer({ allergens }: AllergenProps) {
    const { t } = useTranslation();
    const params = useParams();

    return (
        <Typography sx={{ mr: '3.125rem', ml: '3.438rem', mt: '0.625rem', mb: '0.625rem' }} variant="subtitle2" gutterBottom className="center white">
            {t('allergens') + ": " + allergens.map(allergen => allergen.name).join(', ')}
            <Link component={RouterLink} to={`${HOMEPAGE}/${params.restaurantId}/${ALLGERNS_URL}`} style={{ textDecoration: 'none' }}>{"  " + t('showDetails')}</Link>
        </Typography>
    );
}